import { registerGuideTarget } from '../engine/guide/registry'
import { guideState } from '../engine/guide/state'

// Resolve refs lazily: Vuetify dialogs and menus mount their content on demand.
export default {
  computed: { chatGuideActive() { return guideState.running || guideState.picking } },
  mounted() { this._chatGuideRemovers = []; this.syncChatGuideTargets() },
  updated() { this.syncChatGuideTargets() },
  beforeDestroy() { this.clearChatGuideTargets() },
  methods: {
    clearChatGuideTargets() {
      const removers = this._chatGuideRemovers || []
      removers.forEach(remove => remove())
      this._chatGuideRemovers = []
    },
    syncChatGuideTargets() {
      this.clearChatGuideTargets()
      const definitions = this.chatGuideTargets ? this.chatGuideTargets() : []
      definitions.forEach(definition => {
        const { key, ref, ...options } = definition
        const element = () => {
          const value = this.$refs[ref]
          return value && (value.$el || value)
        }
        const node = element()
        if (node && node.setAttribute) node.setAttribute('data-guide-target', key)
        this._chatGuideRemovers.push(registerGuideTarget(key, { element, ...options }))
      })
    }
  }
}
